'use client'
import React, { type PropsWithChildren } from 'react'

import type { SiteDef } from '../../site-def'

import DesktopHeader from './desktop'
import MobileHeader from './mobile'
import { cn } from '@hanzo/ui'
import { type LogoVariant } from '../logo'


  /** children will render furthest right */
const Header: React.FC<{
  siteDef: SiteDef
  className?: string
  /** Letters alone top left. The mark is the assistant's, bottom right. */
  logoVariant?: LogoVariant
} & PropsWithChildren> = ({
  siteDef,
  className = '',
  children,
  logoVariant = siteDef.logoVariant ?? 'wordmark'
}) => {

    // TODO
    const [open, setOpen] = React.useState<boolean>(false);

    const { nav: { common, featured = [] }, currentAs, noAuth, commerce } = siteDef
    const links = common

    return (<>
      <DesktopHeader
        className={cn(className, 'hidden md:flex')}
        links={links}
        actions={featured}
        currentAs={currentAs}
        noAuth={noAuth}
        noCommerce={!!!commerce}
        logoVariant={logoVariant}
      >{children}</DesktopHeader>
      <MobileHeader
        className={cn(className, 'md:hidden')}
        links={links}
        actions={featured}
        currentAs={currentAs}
        setChatbotOpen={setOpen}
        noAuth={noAuth}
        noCommerce={!!!commerce}
      />
    </>)
  }

export default Header
